import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import Avatar from '../../../paginas/img/avatar.jpg'
import HeaderTabla from '../../componentes/HeaderTabla'
import BotonesFormulario from '../../componentes/BotonesFormulario'
import moment from 'moment'

const VerEstados = ({ data }) => {


	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['Id', 'Fecha de Envio', 'Mensaje Masivo']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td>{item.id}</td>
								<td>{item.fecha_envio}</td>
								<td className='text-center'>{item.mensaje}</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerEstados